import * as React from 'react';
import {
  Panel,
  PanelType,
  IPanelProps,
  IStyleFunctionOrObject,
  IPanelStyleProps,
  IPanelStyles,
  Pivot,
  PivotItem,
  Icon,
  MessageBar,
  MessageBarType,
  ILayerProps,
} from '@fluentui/react';
import '../AnalyticsView/CreateAnalyticsViewStyle.css';
import 'src/styles/Utility.css';
import { AnalyticsViewList } from './AnalyticsViewList';
import { AnalyticsViewCreatePanel } from './AVCreatePanel';
import { UATConstants } from 'src/Common/Models/UATConstants';

export interface AnalyticsViewPanelProps {
  showAnalyticsViewPanel: boolean;
  panelProps?: IPanelProps | undefined;
  isPanelVisible: boolean;
  onPanelDismiss: Function;
  panelStyles?: IStyleFunctionOrObject<IPanelStyleProps, IPanelStyles> | undefined;
}

export interface AnalyticsViewPanelState {
  formMode: string;
  showAVCreatePanel: boolean;
  viewId: string;
  pivotOption: string;
  reloadPostUpdate: boolean;
  showMessage: boolean;
  message: string;
}

export class AnalyticsViewPanel extends React.Component<
  any,
  AnalyticsViewPanelState,
  AnalyticsViewPanelProps
> {
  constructor(props: any) {
    super(props);
    this.state = {
      formMode: 'New',
      showAVCreatePanel: false,
      viewId: '',
      pivotOption: '0',
      reloadPostUpdate: false,
      showMessage: false,
      message: '',
    };

    this.HandleonPanelDismiss = this.HandleonPanelDismiss.bind(this);
    this.showMessage = this.showMessage.bind(this);
  }

  private handleAddButtonClick = () => {
    window.scrollTo(0, 0);
    this.setState({ showAVCreatePanel: true, formMode: 'New', viewId: '' });
  };

  private HandleonPanelDismiss = () => {
    this.setState({ showAVCreatePanel: false, formMode: '', viewId: '' });
  };

  private editCallBack = (id: any) => {
    this.setState({
      showAVCreatePanel: true,
      formMode: 'Edit',
      viewId: id,
    });
  };

  private showMessage = (msg: string) => {
    this.setState({ message: msg });
    this.setState({ showMessage: true });
    setTimeout(() => {
      this.setState({ showMessage: false });
    }, 3000);
  };
  private renderButton = (props: any, defaultRender: any) => {
    return (
      <span onClick={props.onClick} className='cursor-pointer'>
        <Icon
          iconName={UATConstants.PlaceholdersAndTitles.Add}
          styles={{
            root: {
              marginBottom: 0,
              color: 'rgb(0, 120, 212)',
              marginRight: '4px',
            },
          }}
        />
        {UATConstants.PlaceholdersAndTitles.NewView}
      </span>
    );
  };

  private layerProps: ILayerProps = {
    eventBubblingEnabled: true,
  };

  render() {
    return (
      <div className='buttonCustomFilterPanelContainer'>
        <div className='customFilterContainer'>
          <Panel
            type={PanelType.custom}
            className='actionPanelLeftPadding'
            layerProps={this.layerProps}
            customWidth={'85%'}
            hasCloseButton={true}
            headerText={UATConstants.PlaceholdersAndTitles.AnalyticsViews}
            isOpen={this.props.isPanelVisible}
            onDismiss={() => this.props.onPanelDismiss()}
            styles={{ contentInner: { backgroundColor: '#ffffff' } }}
            closeButtonAriaLabel={UATConstants.PlaceholdersAndTitles.ConflictCloseButtonLabel}>
            {this.state.showMessage && (
              <div className='av-messageHeaderMiddle'>
                <MessageBar
                  messageBarType={MessageBarType.success}
                  isMultiline={false}
                  className='messageBar'>
                  {this.state.message}
                </MessageBar>
              </div>
            )}
            <div className='createActionContainer'>
              <Pivot selectedKey={this.state.pivotOption}>
                <PivotItem headerText='All'>
                  {!this.state.showAVCreatePanel && (
                    <AnalyticsViewList
                      editCallBack={this.editCallBack}
                      reload={this.state.reloadPostUpdate}
                      onShowMessage={this.showMessage}
                    />
                  )}
                </PivotItem>
                <PivotItem
                  onRenderItemLink={(props, defaultRender) =>
                    this.renderButton(
                      {
                        ...props,
                        onClick: this.handleAddButtonClick,
                      },
                      defaultRender
                    )
                  }></PivotItem>
              </Pivot>
              {this.state.showAVCreatePanel && (
                <AnalyticsViewCreatePanel
                  showPanel={this.state.showAVCreatePanel}
                  formMode={this.state.formMode}
                  viewId={this.state.viewId}
                  onPanelDismiss={this.HandleonPanelDismiss}
                  onShowMessage={this.showMessage}
                />
              )}
            </div>
          </Panel>
        </div>
      </div>
    );
  }
}
